import { c as _c } from "react/compiler-runtime";
import { useTranslations } from '@material-bank/i18n';
import { Form, Input, z, createFormSchema, SubmitHandler } from '@material-bank/mtag-forms';
function getLoginSchema(emailValidationMessage: string, passwordValidationMessage: string) {
  return z.object({
    email: z.string().email(emailValidationMessage),
    password: z.string().min(8, passwordValidationMessage),
    rememberMe: z.boolean().optional()
  });
}
export type LoginFormData = z.infer<ReturnType<typeof getLoginSchema>>;
type LoginProps = {
  isLoading?: boolean;
  onSubmit: SubmitHandler<LoginFormData>;
  ref?: React.Ref<HTMLFormElement>;
};
export function Login(t0) {
  const $ = _c(43);
  const {
    isLoading: t1,
    onSubmit,
    ref
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const t = useTranslations("authentication.loginForm");
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[0] !== ref || $[1] !== t) {
    const loginSchema = getLoginSchema(t("emailValidation"), t("passwordValidation"));
    T0 = Form;
    t2 = ref;
    t3 = "login-form";
    t4 = createFormSchema(loginSchema);
    $[0] = ref;
    $[1] = t;
    $[2] = T0;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    T0 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("emailLabel");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("emailPlaceholder");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isLoading || $[11] !== t5 || $[12] !== t6) {
    t7 = <Input name="email" label={t5} type="email" placeholder={t6} disabled={isLoading} />;
    $[10] = isLoading;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("passwordLabel");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("passwordPlaceholder");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== isLoading || $[19] !== t8 || $[20] !== t9) {
    t10 = <Input name="password" label={t8} type="password" placeholder={t9} disabled={isLoading} />;
    $[18] = isLoading;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <input type="checkbox" name="rememberMe" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("rememberMe");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <label className="login-form__remember">{t11}{t12}</label>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isLoading || $[28] !== t) {
    t14 = isLoading ? t("submitButtonLoading") : t("submitButton");
    $[27] = isLoading;
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isLoading || $[31] !== t14) {
    t15 = <button type="submit" disabled={isLoading} className="login-form__submit">{t14}</button>;
    $[30] = isLoading;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== T0 || $[34] !== onSubmit || $[35] !== t10 || $[36] !== t13 || $[37] !== t15 || $[38] !== t2 || $[39] !== t3 || $[40] !== t4 || $[41] !== t7) {
    t16 = <T0 ref={t2} className={t3} formProps={t4} onSubmit={onSubmit}>{t7}{t10}{t13}{t15}</T0>;
    $[33] = T0;
    $[34] = onSubmit;
    $[35] = t10;
    $[36] = t13;
    $[37] = t15;
    $[38] = t2;
    $[39] = t3;
    $[40] = t4;
    $[41] = t7;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}